import React from 'react';
import styled from '@emotion/styled';

const SearchContainer = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  background-color: white;
  padding: 10px;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  z-index: 12;
`;

const SelectInput = styled.select`
  border: none;
  outline: none;
  font-size: 14px;
  margin-left: 10px;
  width: 200px;
  background: transparent;
  cursor: pointer;
`;

const SearchIcon = styled.span`
  font-size: 16px;
`;

const SearchBar = ({ topics, selectedTopic, onTopicChange }) => {
  return (
    <SearchContainer>
      <SearchIcon>🔍</SearchIcon>
      <SelectInput 
        value={selectedTopic || ''} 
        onChange={(e) => onTopicChange(e.target.value)}
        onKeyDown={(e) => {
          const searchText = e.target.value.toLowerCase();
          const filteredTopics = topics.filter(topic => 
            topic.topic.toLowerCase().includes(searchText)
          );
          if (e.key === 'Enter' && filteredTopics.length > 0) {
            onTopicChange(filteredTopics[0].id);
          }
        }}
        list="topics-list"
      >
        <option value="">All Topics</option>
        {topics.map((topic) => (
          <option key={topic.id} value={topic.id}>
            {topic.topic}
          </option>
        ))}
      </SelectInput>
      <datalist id="topics-list">
        {topics.map((topic) => (
          <option key={topic.id} value={topic.topic} />
        ))}
      </datalist>
    </SearchContainer>
  );
};

export default SearchBar; 